import { Meeting } from './fetchMeetings';

export default function getDefaultMeetingsLink(meetingLinks: Meeting[]) {
  const defaultLink = meetingLinks.find((link) => link.isDefaultLink);
  return defaultLink || meetingLinks[0];
}
